<mat-card>
  <app-card-header
    [title]="title"
    [subtitle]="nombreEntidad"
    icono="account_balance_wallet"
    [botonCerrar]="true"
    (cerrar)="this.dialogRef.close(false)"
  ></app-card-header>

  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <!-- Aviso según el estado elegido -->
        @if (!isCuentaSuspendida) {
          <app-info-banner
            icon="info"
            title="¿Qué es una Cuenta Suspendida?"
            message="Al suspender una cuenta,
            <strong style='color: #ef5350'>
              todos los eventos generados no serán atendibles hasta tiempo
              indeterminado
            </strong>
            y pasarán directamente al histórico sin generar notificaciones. La
            cuenta deberá ser habilitada para que los eventos puedan ser
            atendidos nuevamente."
            margin="12px 0 0 0"
          ></app-info-banner>
        } @else {
          <app-info-banner
            icon="warning"
            title="Atención: Estado Suspendido"
            message=" Con este estado seleccionado,
            <strong style='color: #ef5350'>los eventos no serán atendidos</strong>
            y se enviarán directamente al histórico."
            margin="12px 0 0 0"
            color="yellow"
          ></app-info-banner>
        }

        <!-- Estado de la Cuenta -->
        <app-content-card title="Estado de la Cuenta" icon="account_circle">
          <ng-select
            style="width: 100%"
            formControlName="estado"
            placeholder="Estado"
            [items]="estados"
            [clearable]="false"
            appendTo="body"
            notFoundText="Sin resultados"
          ></ng-select>
        </app-content-card>

        <!-- Detalles y Motivos -->
        <app-content-card title="Detalles y Motivos" icon="description">
          <ng-select
            style="width: 100%"
            formControlName="motivos"
            placeholder="Motivos"
            [items]="motivos"
            [multiple]="true"
            [closeOnSelect]="false"
            appendTo="body"
            notFoundText="Sin resultados"
          ></ng-select>
          <small class="ayuda">
            Seleccioná uno o más motivos para el cambio de estado
          </small>

          <mat-form-field>
            <mat-label>Nota</mat-label>
            <textarea
              matInput
              formControlName="nota"
              rows="3"
              placeholder="Agregá información adicional sobre el cambio de estado"
            ></textarea>
            <mat-hint>Información adicional sobre el cambio de estado</mat-hint>
          </mat-form-field>
        </app-content-card>
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button
          irxBoton="secundario"
          type="button"
          (click)="this.dialogRef.close(false)"
        >
          Cancelar
        </button>
        <button
          irxBoton="principal"
          type="submit"
          [disabled]="!this.form.valid || this.loading"
        >
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </mat-card-actions>
    </form>
  }
</mat-card>
